import {
  PortfolioPerformanceApi,
  PortfolioTradesApi,
} from "../../../../generated-api-v3";
import { API_BASE } from "../../constants/constants";
import { useQuery } from "react-query";
import { useGlobalPeriod } from "../context";
import moment from "moment";
import { Period } from "@iliotech/generated-api";

export const useHistoricDistribution = (
  portfolioId: string,
  frequency: "Monthly" | "Daily" = "Daily",
  overridePeriod?: Period
) => {
  const { period: contextPeriod } = useGlobalPeriod();
  const period = overridePeriod || contextPeriod;
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;

  const api = new PortfolioPerformanceApi(undefined, `${API_BASE}/api`);

  return useQuery(
    ["portfolio-historic-returns", { portfolioId, to, from, frequency }],
    () => api.getHistoricReturns(portfolioId, frequency, from, to),
    {
      enabled: !!portfolioId,
    }
  );
};
